<div>
  <router-outlet />
</div>